import { FC, ReactElement } from 'react';

import classNames from 'classnames';

import { User } from '../UI';

import { IAvatarProps } from './avatar.interface';
import styles from './avatar.module.scss';

import { getOrganizationNameAcronym } from 'utils';

const Avatar: FC<IAvatarProps> = (props): ReactElement => {
  const { size, mode, image, isActive, organizationName } = props;

  const avatarClassNames = classNames(styles.avatar, {
    [styles[`avatar--${size}`]]: size,
    [styles['avatar--active']]: isActive,
  });

  const defaultOrgText = classNames(styles.avatar__text, {
    [styles[`avatar__text--${size}`]]: size,
  });

  function getInnerImg(): ReactElement | null {
    if (image) {
      return <img src={image} alt="user-avatar" />;
    }
    if (mode === 'user') {
      return <User color="var(--sk-icon-subtle)" />;
    }
    if (mode === 'organization') {
      return (
        <span className={defaultOrgText}>
          {organizationName ? getOrganizationNameAcronym(organizationName!) : ''}
        </span>
      );
    }
    return null;
  }

  return <div className={avatarClassNames}>{getInnerImg()}</div>;
};

export { Avatar };
